import React from "react";
import { Label } from "./Label";

interface ToggleSwitchProps {
  name: string;
  label?: string;
  required?: boolean;
  tooltip?: string;
  selected: boolean;
  onChange: (value: boolean) => void;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  name,
  label,
  onChange,
  selected,
  required,
  tooltip,
}) => {
  return (
    <div className="flex items-center justify-between mb-4">
      {label && (
        <Label
          htmlFor={name}
          required={required}
          label={label}
          tooltip={tooltip}
        />
      )}

      <button
        id={name}
        type="button"
        onClick={() => onChange(!selected)}
        className={`w-10 h-6 flex items-center rounded-full p-1 transition-colors ${
          selected ? "bg-gray-700" : "bg-gray-300"
        }`}
      >
        <div
          className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform ${
            selected ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </button>
    </div>
  );
};
